import Main from '../../components/Main';
import Navbar from '../../components/Navbar';
import Header from '../../components/Header';
import About from '../../components/About';
import Services from '../../components/Services';
import Projects from '../../components/Projects';
import Resume from '../../components/Resume';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';
import Skills from '../../components/Skills';

const Home = () => {
    return (
        <Main>
            <Navbar />
            <Header />
            <About />
            <Resume />
            <Services />
            <Projects />
            <Skills />
            <Contact />
            <Footer />
        </Main>
    );
};

export default Home;
